<app-page-header>{{ 'Request Forms' }}</app-page-header>

<app-table class="request-forms-table"
           [columnMap]="columnMap"
           [columnSort]="columnSort"
           [type]="tableType"
           [rowSelectable]="true"
           (rowSelect)="goToRequestForm($event)"
           (showFilters)="openFilters($event)"
           matSort
           matSortActive="name"
           matSortDirection="asc"
           matSortDisableClear="true">
    <ng-container matColumnDef="mobile">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[0].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.name">
            <app-avatar-block [iconImage]="row.iconImage">
                <a [routerLink]="['submissions']" [queryParams]="{ form: row.name, state: 'open' }" avatarTitle>{{ row.name }}</a>
                <span avatarDescription>{{ row.organizationCount | i18nPlural: organizationsMapping }}</span>
            </app-avatar-block>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[1].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.name">
            <app-avatar-block [iconImage]="row.iconImage">
                <a [routerLink]="['submissions']" [queryParams]="{ form: row.name, state: 'open' }" avatarTitle>{{ row.name }}</a>
                <span avatarDescription>{{ row.organizationCount | i18nPlural: organizationsMapping }}</span>
            </app-avatar-block>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="lastSubmissionDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header><span class="no-wrap">{{ columnMap[2].title }}</span></mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.lastSubmissionDate">
            {{ row.lastSubmissionDate | legfiDate: 'MM/DD/YYYY' }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="approversCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" numberCell><span class="no-wrap">{{ columnMap[3].title }}</span></mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.approversCount" useZero="true" numberCell>
            {{ row.approversCount | number:'1.0':'en-US' }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="openSubmissionsCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" numberCell><span class="no-wrap">{{ columnMap[4].title }}</span></mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.openSubmissionsCount" useZero="true" numberCell>
            {{ row.openSubmissionsCount | number:'1.0':'en-US' }}
        </mat-cell>
    </ng-container>

    <app-empty-state [icon]="'requests'">
        <span emptyStateTitle>{{ 'No request forms so far...' }}</span>
    </app-empty-state>
</app-table>
